import React, { Component } from 'react';




export default class DownloadApp extends Component {

    render() {

        return (
            <div className="DownloadApp">
                <div className="download-contet">
                    <h5>
                        دانلود اپلیکیشن
                    </h5>
                    <p className="download-p">
                        با اپلیکیشن اصناف
                        <br />
                        راحت تر و سریعتر کسب و کار خود را معرفی نمایید.
                        <br />
                        دانلود برای تمامی نسخه ها

                    </p>
                    <p>
                        <img src="/assets/images/bazzar.png" alt="کافه بازار" />
                        <img src="/assets/images/googleplay.png" alt="google-play" />

                    </p>
                </div>
                <div className="download-img">
                    <img src="/assets/images/app.png" alt="اپلیکیشن اصناف" />
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/home/downloadapp.jsx